import { render } from "./CarruselComponent.vue?vue&type=template&id=2c106cab&scoped=true"
import script from "./CarruselComponent.vue?vue&type=script&lang=js"
export * from "./CarruselComponent.vue?vue&type=script&lang=js"

import "./CarruselComponent.vue?vue&type=style&index=0&id=2c106cab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c106cab"]])

export default __exports__